import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { ErrorHandler } from '@angular/core';
import { ApplicationInsightsService } from '../app/domain/applicationinsights-displayer';

export const provideApplicationInsights = () => {
  return [
    ApplicationInsightsService,
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
  ];
};